<template>
    <div />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHead, useSeoMeta } from '#imports'
import type { HblCategory } from '@/utils/types'
import { normalizeSlashes } from '@/utils/helper'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    data: HblCategory
}>()

const route = useRoute()
const config = useRuntimeConfig().public
const { isLocalisedRoute } = useLocalisation()
const routeLocale = isLocalisedRoute(route.path)

let canonicalUrl = config?.appBaseUrl + route?.path
if (props?.data?.url != null) {
    canonicalUrl = config?.appBaseUrl + props?.data?.url

    if (routeLocale) {
        canonicalUrl = config?.appBaseUrl + routeLocale + '/' + props?.data?.url
    }
}

canonicalUrl = normalizeSlashes(canonicalUrl)

const ogTitle = computed(() => props.data.metaTitle ?? props.data.name)
const ogImage = computed(() => props.data.media?.url)

useSeoMeta({
    description: () => props.data.metaDescription,
    ogType: 'website',
    ogSiteName: ogTitle,
    ogTitle,
    ogDescription: () => props.data.metaDescription,
    ogUrl: canonicalUrl,
    ogImage,
    ogImageAlt: ogTitle
})

useHead({
    title: (props.data.metaTitle ?? props.data.name) + ' | ' + t('page.title'),
    link: [
        {
            rel: 'canonical',
            href: canonicalUrl
        }
    ]
})
</script>
